module.exports = __webpack_public_path__ + "assets/img/index-project2-1.f52d7738.jpg";